import React from 'react'
import {  Input, Form } from 'antd'
const TextArea = ({ data }) => {

    console.log("============= TextArea", TextArea);

    const renderQuestion = () => {

        return <Form.Item name={data.questionLabel}
            rules={[{ required: true, message: 'Please Add Some comment!' }]} >
            <Input.TextArea rows={6} />
        </Form.Item>

    }

    return (
        <div style={{ padding: '10px 10px 30px 31px' }}>
            <h5 className="gx-blue-font gx-mb-3">{data.questionLabel}</h5>
            {renderQuestion()}
        </div>
    )
}

export default TextArea
